import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DoctorsListPageRoutingModule } from './doctors-list-routing.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DoctorsListPage } from './doctors-list.page';
import { CalendarModule } from 'ion2-calendar';
import { InViewportModule } from 'ng-in-viewport';
import {ScrollingModule} from '@angular/cdk/scrolling';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DoctorsListPageRoutingModule,
    CalendarModule,
    InViewportModule,
    ScrollingModule,
    InfiniteScrollModule
  ],
  declarations: [DoctorsListPage]
})
export class DoctorsListPageModule { }
